import { Button } from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import DropdownIcon from 'public/static/images/icons/Dropdown_arrow.svg';
import { MouseEvent, useEffect, useState } from 'react';

import { PreloaderOverlay } from '~components/PreloaderOverlay/PreloaderOverlay';
import { env } from '~constants/env';
import { useBreakpoints } from '~hooks/useBreakpoints';
import SignInIcon from '~public/static/images/icons/door_arrow_left_outline_28.svg';
import DoorIconRight from '~public/static/images/icons/door_arrow_right_outline_28.svg';
import { Goals } from '~services/Goals';
import { McsApi } from '~services/McsApi';
import { URLS } from '~types/Urls.types';

import styles from './HeaderCloudUser.module.scss';
import { HeaderCloudUserProps } from './HeaderCloudUser.types';

export const HeaderCloudUser = observer(
  ({ mod, className }: HeaderCloudUserProps) => {
    const [, { isMobile, isDesktop }] = useBreakpoints();
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState<string | null>(null);
    const [menuActive, setMenuActive] = useState(false);

    useEffect(() => {
      McsApi.getUser().then((gottenUser) => setUser(gottenUser));
    }, []);

    function handleMenuToggle() {
      setMenuActive(!menuActive);
    }

    async function handleSignInClick(event: any) {
      event.preventDefault();

      setIsLoading(true);

      await McsApi.signIn().finally(() => {
        setIsLoading(false);
      });
    }

    async function handleSignUpClick(event: any) {
      event.preventDefault();
      setIsLoading(true);

      Goals.gtag4({ event: 'click_registration' });
      Goals.ym({
        event: 'reachGoal',
        action: 'click_RegistrationStart',
      });

      await McsApi.signUp().finally(() => {
        setIsLoading(false);
      });
    }

    function handleSignOutClick(event: MouseEvent<HTMLAnchorElement>) {
      event.preventDefault();

      return McsApi.signOut();
    }

    return (
      <div
        className={classNames(styles.wrapper, className, {
          [styles[mod]]: mod,
        })}
      >
        {user ? (
          <>
            {isDesktop && (
              <Button
                href={URLS.App}
                dataTest="appLink"
                mod="secondary"
                size="m"
                icon={`${env.static}/images/icons/vk_cloud_active.svg`}
              >
                Личный кабинет
              </Button>
            )}
            <div
              onClick={(event) => event.stopPropagation()}
              className={classNames(styles.userMenu, {
                [styles.userMenuActive]: menuActive,
              })}
            >
              <div className={styles.userMenuHead} onClick={handleMenuToggle}>
                <div className={styles.userAvatar}>
                  {user.charAt(0).toUpperCase()}
                </div>
                <DropdownIcon className={styles.userMenuArrow} />
              </div>
              {menuActive && (
                <div className={styles.userMenuDropdown}>
                  <div className={styles.userName}>{user}</div>
                  <Link
                    className={styles.userMenuItem}
                    onClick={handleSignOutClick}
                    href={URLS.AppSignOut}
                  >
                    <DoorIconRight className={styles.icon} />
                    Выйти из аккаунта
                  </Link>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            {isMobile ? (
              <Link
                className={classNames(styles.userSignIn, styles.linkView)}
                href={URLS.App}
              >
                Вход / Регистрация
              </Link>
            ) : (
              <div className={styles.actionsDesktop}>
                <Button
                  mod="secondary"
                  icon={<SignInIcon />}
                  dataTest="signIn"
                  href={URLS.AppSignIn}
                  size="m"
                  onClick={handleSignInClick}
                >
                  Вход
                </Button>
                <Button
                  href={URLS.AppSignUp}
                  mod="primary"
                  dataTest="signUp"
                  size="m"
                  onClick={handleSignUpClick}
                >
                  Регистрация
                </Button>
              </div>
            )}
          </>
        )}
        <PreloaderOverlay active={isLoading} />
      </div>
    );
  },
);
